export default __webpack_public_path__ + "static/media/Compound.4b04f06e.svg";